const objectives = {
  addTarget: 'Add target',
  addTargetPoint: 'Add point',
  aheadOfTarget: 'Ahead of {{name}} ({{expected}})',
  allObjectives: 'All Objectives',
  archivedObjectives: 'Archived Projects',
  behindTarget: 'Behind {{name}} ({{expected}})',
  bestValue: 'Best',
  cancelledObjectives: 'Cancelled Objectives',
  completeObjectives: 'Complete Objectives',
  createAnObjective: 'Create an Objective',
  currentValue: 'Current value',
  durationFormat: 'Time (h:mm:ss)',
  durationPlaceholder: 'h:mm:ss',
  distanceFromTarget: '{{distance}} from target',
  distanceFromTargetTrack: '{{distance}} from {{name}} ({{expected}})',
  failedObjectives: 'Failed Objectives',
  goal: 'Goal',
  goalFrequency: 'Goal frequency',
  goalKind: 'Goal type',
  goalKindAround: 'Around a target',
  goalKindHelpAROUND: 'Log the value on a given date. Closer to the target is better, such as a weight.',
  goalKindHelpHIGHEST: 'Log the value on a given date. Higher is better, such as a bank balance or a cumulative score.',
  goalKindHelpLOWEST: 'Log the value on a given date. Lower is better.',
  goalKindHelpREACH: 'Log each step toward the goal. The latest value is the current progress.',
  goalKindHighest: 'Highest possible',
  goalKindLowest: 'Lowest possible',
  goalKindReach: 'Reach a goal',
  goalTolerance: 'Tolerance',
  incompleteObjectives: 'Incomplete Objectives',
  initialProgress: 'Initial Progress',
  invalidDuration: 'Enter a time as h:mm:ss, mm:ss, or seconds',
  logProgress: 'Log progress',
  noObjectivesToDisplay: 'No objectives to display',
  noProgressEntries: 'No progress logged yet',
  noTargets: 'No targets yet',
  noUnit: 'None',
  objective: 'Objective',
  objectiveAroundValue: '{{value}} (target {{target}})',
  objectiveCreated: 'Created the objective',
  objectiveDeleted: 'Deleted the objective',
  objectiveHistoryAssigneeCleared: 'Assignee cleared',
  objectiveHistoryAssigneeSet: 'Assignee set to {{assignee}}',
  objectiveHistoryCompleted: 'Marked as completed',
  objectiveHistoryDeadlineCleared: 'Deadline cleared',
  objectiveHistoryDeadlineSet: 'Deadline set to {{date}}',
  objectiveHistoryFormatCleared: 'Display set to a number',
  objectiveHistoryFormatSet: 'Display set to {{format}}',
  objectiveHistoryGoalFrequencyCleared: 'Goal frequency cleared',
  objectiveHistoryGoalFrequencySet: 'Goal frequency set to {{frequency}}',
  objectiveHistoryGoalKindCleared: 'Goal type cleared',
  objectiveHistoryGoalKindSet: 'Goal type set to {{kind}}',
  objectiveHistoryProgressCleared: 'Progress cleared',
  objectiveHistoryProgressSet: 'Progress set to {{value}}',
  objectiveHistoryProjectsAssigned_one: 'Assigned to {{projects}}',
  objectiveHistoryProjectsAssigned_other: 'Assigned to {{projects}}',
  objectiveHistoryProjectsUnassigned_one: 'Unassigned from {{projects}}',
  objectiveHistoryProjectsUnassigned_other: 'Unassigned from {{projects}}',
  objectiveHistoryReopened: 'Reopened',
  objectiveHistoryStatusSet: 'Status set to {{status}}',
  objectiveHistoryUnitCleared: 'Unit cleared',
  objectiveHistoryUnitSet: 'Unit set to {{unit}}',
  objectives: 'Objectives',
  objectiveUpdated: 'Updated the objective',
  objectiveUpdatedFields: 'Updated {{fields}}',
  ongoingObjectives: 'Ongoing Objectives',
  progressChartPoint: '{{date}}: {{value}}',
  progressOverTime: 'Progress over time',
  recordedOn: 'Recorded on',
  saveTargets: 'Save targets',
  target: 'Target',
  targetName: 'Target name',
  targetPointValue: 'Value',
  targets: 'Targets',
  unit: 'Unit',
  value: 'Value',
  xSelectedObjectives_one: '{{count}} selected objective',
  xSelectedObjectives_other: '{{count}} selected objectives',
};

export default objectives;
